import React from "react";
import CustomStatusTask from "../components/CustomStatusTask";

function PendingTaskPage() {
  return (
    <div>
      <CustomStatusTask StatusFilter="Pending" />
    </div>
  );
}

export default PendingTaskPage;

